module.exports = __webpack_public_path__ + "static/media/6.Thumbs Up 2.83125e47.gif";